import CRUDActions from './CRUD';
import Country from '../api/country';

class CountryCrud extends CRUDActions {
  prefix = 'countries';

  get _model() {
    return Country;
  }

}

export default new CountryCrud();




// WEBPACK FOOTER //
// ./src/actions/countries.js